import { useAppContext } from '@prisjakt/ui-app-context';
import { H4Text, BodySmallText } from '@prisjakt/ui/text/variants';
import React, { useState } from 'react';
import { useLocation } from 'react-router';
import { pushEvent } from 'src/client/data-layer';
import { useLocalStorage } from 'src/hooks/use-localstorage';
import { IOptions, IQuestion, Questions } from './questions';
import { SurveyLink, FeedbackImage } from './styles';

export const SearchRelevancyQuestions = () => {
  const location = useLocation();
  const { t, market } = useAppContext();
  const [_, setLocalStorage] = useLocalStorage(
    'pj:searchRelevancyFeedbackTime',
    0
  );
  const [answered, setAnswered] = useState<number>(0);

  const options: IOptions[] = [
    { value: 1, label: t('feedback', 'relevancy.not-relevant') },
    { value: 2, label: '' },
    { value: 3, label: '' },
    { value: 4, label: '' },
    { value: 5, label: t('feedback', 'relevancy.very-relevant') },
  ];

  const questions: IQuestion[] = [
    {
      name: 'relevancy',
      question: t('feedback', 'relevancy.question'),
      score: 0,
    },
  ];

  const handleSubmit = (answeredQuestions: IQuestion[]) => {
    const feedbackData: { relevancy?: number; query?: string } = {};

    answeredQuestions.forEach(question => {
      switch (question.name) {
        case 'relevancy':
          feedbackData.relevancy = question.score;
          break;
        default:
          break;
      }
    });

    const url = location.search;
    const searchParam = new URLSearchParams(url).get('search') || '';
    feedbackData.query = searchParam;

    // Push the score to GTM and Amplitude where it will be stored
    pushEvent('searchRelevancyFeedbackSubmitted', feedbackData);
    setLocalStorage(new Date().valueOf());
    setAnswered(feedbackData.relevancy || 0);
  };

  const thankYouScreen = () => {
    let feedbackForm = null;
    const isSweden = market.code.toLocaleLowerCase() === 'se';

    if (answered <= 2 && isSweden) {
      const feedbackFormLink = (
        <SurveyLink
          target="_blank"
          rel="noreferrer"
          href="https://prisjaktse.typeform.com/to/MQWPMKnt"
        >
          {t('feedback', 'relevancy.take-a-survey')}
        </SurveyLink>
      );

      feedbackForm = (
        <BodySmallText>
          {t('feedback', 'relevancy.help-us-with-searchresult')}{' '}
          {feedbackFormLink}
        </BodySmallText>
      );
    }
    return (
      <>
        <FeedbackImage
          src={`${market.cdn}/g/rfe/illustrations/thumb-up-144px.png`}
          alt=""
        />
        <div>
          <H4Text>{t('feedback', 'relevancy.thank-you')}</H4Text>
          {feedbackForm}
        </div>
      </>
    );
  };

  return (
    <Questions
      questions={questions}
      options={options}
      thankYouScreen={thankYouScreen()}
      onSubmit={answeredQuestions => handleSubmit(answeredQuestions)}
    />
  );
};
